module.exports = __webpack_public_path__ + "media/images/logo-Beasy-0a7b76193920fbfed6a9a96531e5e61f.png";